export const BG_CHECK_PACKAGES = [
  {
    code: 'STATEWIDE_PKG',
    name: 'Statewide Background Check',
    products: [],
    description: 'SSN address trace and Statewide Criminal search',
  },
  {
    code: 'PKG_BASIC',
    name: 'Criminal History (National)',
    products: [],
    description:
      'Includes checks of the National Criminal Database Search, One Name Submission.',
  },
  {
    code: 'PKG_STANDARD',
    name: 'Criminal and Address Check (National and Local)',
    products: [],
    description:
      'Includes National and County criminal history, Global terror watchlist.',
  },
  {
    code: 'PKG_PRO',
    name: '7-year Criminal History and Address Check',
    products: [],
    description:
      'SSN address trace, National Criminal search, and seven-year historical check at county criminal level.',
  },
  {
    code: 'PKG_EMPTY',
    name: 'Custom check',
    products: [],
    description: '',
    isCustom: true,
  },
];

export const BANKING_LENDING_BG_CHECK_PACKAGES = [
  {
    code: 'MAINTENANCE_PACKAGE',
    name: 'Maintenance',
    products: [],
    description: 'Address Mover, OFAC, Global Watch.',
  },
  {
    code: 'STANDARD_PKG_SOLVENTH',
    name: 'Standard',
    products: [],
    description:
      'Address Mover, OFAC, Global Watch, Felony/Misdemeanor, National Criminal, Statewide Criminal, National Sex Offender.',
  },
  {
    code: 'ENHANCED_PACKAGE',
    name: 'Enhanced',
    products: [],
    description:
      'Address Mover, OFAC, Global Watch, Felony/Misdemeanor, National Criminal, Statewide Criminal, National Sex Offender, Federal Criminal, Civil Upper.',
  },
];

export const BG_CHECK_PRODUCTS = [
  { code: 'EDU', name: 'Education Verification' },
  { code: 'EMP', name: 'Employment Verification' },
  { code: 'FACIS1', name: 'FACIS Level 1 Federal Databases Only' },
  { code: 'FACIS', name: 'FACIS Level 3	Federal and all State Databases' },
  { code: 'NCRIM', name: 'National Criminal Database' },
  { code: 'PLV', name: 'Professional License Verification' },
  { code: 'MOV', name: 'SSN Trace' },
  { code: 'TERB', name: 'Global Watch (Terrorist List)' },
  { code: 'OFAC', name: 'Office of Foreign Asset Control (OFAC)' },
  { code: 'FED_CV', name: 'Federal Civil Search' },
  { code: 'FED_BK', name: 'Federal Bankruptcy' },
];
